import React, { useState, useEffect } from "react";
import { HumDataContext } from "./context";

import { getHumData } from "../services/services";

const HumProvider = ({ children }) => {
  const [humData, setHumData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHum = async () => {
      const hum = await getHumData({ lang: "el" })
        .then((response) => {
          if (response) {
            setLoading(false);
            return response;
          } else {
            setLoading(false);
            return [];
          }
        })
        .catch((error) => {
          setLoading(false);
          setError(error);
        });

      setHumData(hum);
    };

    fetchHum();
  }, []);

  return (
    <HumDataContext.Provider value={{ humData, setHumData, loading, error }}>
      {children}
    </HumDataContext.Provider>
  );
};

export default HumProvider;
